<div [ngClass]="['text', theme]">
    <ng-content>
    </ng-content>
    <em class="required" *ngIf="required">&nbsp;*</em>
</div>